import { usePipelineContext } from './usePipelineContext';
import type { DivisionRole, PipelineDivision, PipelineTeam } from '../../../shared/api/tasks.api';

/**
 * Отделение, в которой у человека нужная роль, и команды этого отделения.
 *
 * Роль живёт на членстве, а не на профиле: один человек может быть
 * контент-мейкером в B2G и модератором в редакции. Экран всегда работает с
 * одним отделением, и выбрать его должен не экран, а роль, ради которой он
 * открыт.
 */
export function useDivisionFor(role: DivisionRole): {
  division: PipelineDivision | null;
  teams: PipelineTeam[];
  /** Команда, которую ведёт этот человек. У монтажёра и модератора её нет. */
  ownTeam: PipelineTeam | null;
  isLoading: boolean;
} {
  const { divisions, teams, isLoading, context } = usePipelineContext();

  const division = divisions.find((d) => d.role === role)
    // Руководитель проходит везде: ему показываем его собственное отделение.
    ?? divisions.find((d) => d.role === 'head')
    ?? null;

  const ofDivision = division ? teams.filter((l) => l.divisionId === division.id) : [];

  return {
    division,
    teams: ofDivision,
    ownTeam: ofDivision.find((l) => l.contentMakerId === context?.user.id) ?? null,
    isLoading: isLoading && !context,
  };
}
